import { render, staticRenderFns } from "./ResetEmailSuccessPage.vue?vue&type=template&id=83531726&"
import script from "./ResetEmailSuccessPage.vue?vue&type=script&lang=js&"
export * from "./ResetEmailSuccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports